import React from "react";
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AppFontScaleProvider } from "./theme/fontScale";

// Importing SCSS files
import "./assets/scss/dashlite.scss";
import "./assets/scss/style-email.scss";
import "./App.css"

// Importing the reportWebVitals function
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./store/store";


// Using the new ReactDOM client to create and manage the root
const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      {/* Renders the antd ConfigProvider (antdTheme + user's A/A+/A++ fontSize)
          and applies the root font-size preference — see theme/fontScale.tsx */}
      <AppFontScaleProvider>
        <App />
      </AppFontScaleProvider>
    </BrowserRouter>
  </Provider>
);

// Optional: Measurement of performance in your app
// You can pass a function to log results (for example, reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
